import { StructuralAccountType } from "../../pages/HierachyManagementDashboard/StructuralAccountType";

export const constructHierarchy = (data) => {
    const nodeMap = new Map();
    let rootIndex = 0;

    data.forEach((node) => {
        nodeMap.set(node.accountId, {
            index: node.accountId.toString(),
            isFolder: node.structuralAccountTypeId === StructuralAccountType.Tenant || node.structuralAccountTypeId === StructuralAccountType.Suborg,
            children: [],
            data: {
                name: node.name,
                structuralAccountTypeId: node.structuralAccountTypeId,
                accountId: node.accountId,
                parentId: node.parentId
            },
            canMove: false,
            canRename: false,
        });
    });

    const tenants = [];

    data.forEach((node) => {
        if (!node.parentId) {
            // No parent id, this is the root node
            rootIndex = node.accountId;
            tenants.push(nodeMap.get(node.accountId)); // Root node has no parent
        } else {
            const parent = nodeMap.get(node.parentId);

            if (parent) {
                parent.children.push(nodeMap.get(node.accountId)); // Add child to the parent
            }
        }
    });

    const items = {};

    const buildNodeAndDescendants = (node) => {
        // Sort children: sub orgs first, then locations, then alphabetically within each type
        const sortedChildren = [...node.children].sort((a, b) => {
            const aType = a.data.structuralAccountTypeId;
            const bType = b.data.structuralAccountTypeId;

            // If types are different, sort by type (Suborg=2 before Location=3)
            if (aType !== bType) {
                return aType - bType;
            }

            // If types are the same, sort alphabetically by name (case insensitive)
            return a.data.name.trim().toLowerCase().localeCompare(b.data.name.trim().toLowerCase());
        });

        items[node.index] = {
            index: node.index,
            accountId: node.index,
            isFolder: node.isFolder && node.children.length > 0,
            children: sortedChildren.map((child) => child.index),
            data: {
                ...node.data,
            },
            canMove: node.canMove,
            canRename: node.canRename,
        };

        sortedChildren.forEach(buildNodeAndDescendants);
    };

    buildNodeAndDescendants(tenants[0]);

    items["root"] = {
        children: [rootIndex.toString()]
    }
    return items;
}




/**
 * Build a map: itemId -> hasMoreAtDepth[]
 *
 * items: RCT items map (like your hierarchyData / filteredData)
 * rootId: usually "root"
 * expandedItems: array or Set of item ids that are expanded
 */
export function buildHasMoreAtDepthMap(
    items,
    rootId = "root",
    expandedItems = []
) {
    const expandedSet = new Set(expandedItems);
    const hasMoreAtDepthMap = {};

    function dfsChildren(parentId, depth, parentHasMore) {
        const parent = items[parentId];
        if (!parent?.children?.length) return;

        const childrenIds = parent.children;
        const count = childrenIds.length;

        childrenIds.forEach((childId, index) => {
            const item = items[childId];
            if (!item) return;

            const isLastSibling = index === count - 1;

            // clone ancestor flags (which columns above this node still continue)
            const colStates = parentHasMore.slice();

            // column for THIS parent lives at index = depth
            // depth 0 → Harpal column, 1 → test Org1, etc.
            colStates[depth] = !isLastSibling;

            // store for this node
            hasMoreAtDepthMap[childId] = colStates;

            const isExpanded =
                item.isFolder &&
                expandedSet.has(childId) &&
                Array.isArray(item.children) &&
                item.children.length > 0;

            if (isExpanded) {
                dfsChildren(childId, depth + 1, colStates);
            }
        });
    }

    // start from synthetic root, at depth -1 -> we call children with depth 0
    const root = items[rootId];
    if (root?.children?.length) {
        root.children.forEach((childId) => {
            dfsChildren(childId, 0, []); // depth 0 for tenant level
        });
    }

    return hasMoreAtDepthMap;
}




